import api from "../../../api/api"

const getUnreadCount = () => {
    return new Promise((resolve, reject) => {
        api.get("/user-notification/unread-count").then((res) => {
            if (!res.data.error) {
                resolve(res.data);
            } else {
                reject({ msg: res.data.msg });
            }
          }).catch((error) => {
            reject({ msg: "Something Went Wrong", error: error });
          });
    });
};


const getList = (page = 1) => {
    return new Promise((resolve, reject) => {
        // Passing page as a query parameter (e.g., /user-notification?page=2)
        api.get(`/user-notification?page=${page}`).then((res) => {
            if (!res.data.error) {
                resolve(res.data);
            } else {
                reject({ msg: res.data.msg });
            }
          }).catch((error) => {
            reject({ msg: "Something Went Wrong", error: error });
          });
    });
};


const markAllAsRead = () => {
    return new Promise((resolve, reject) => {
        api.post(`/user-notification/read-all`).then((res) => {
            if (!res.data.error) {
                resolve(res.data);
            } else {
                reject({ msg: res.data.msg });
            }
          }).catch((error) => {
            reject({ msg: "Something Went Wrong", error: error });
          });
    });
};

const essNotificationServices = {
    getUnreadCount,
    getList,
    markAllAsRead
}

export default essNotificationServices